export default __webpack_public_path__ + "media/images/celeste_notification-02bf46fba412eff5fd360399ab48117e.png";